import React from 'react';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';
import { useState } from 'react';

export default function FilterAccordionItem({
  label,
  active,
  children,
}: {
  label: string | React.ReactNode;
  active: boolean;
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className='mb-4 border-b border-dark py-2'>
      <button
        type='button'
        className='flex w-full items-center justify-between font-bold'
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
      >
        <span className='uppercase'>
          {label}{' '}
          {active && (
            <span className='align-middle text-xl text-[#090]'>•</span>
          )}
        </span>
        {isOpen ? <MdExpandLess /> : <MdExpandMore />}
      </button>
      <div className={`${isOpen ? 'mt-2 block' : 'hidden'}`}>{children}</div>
    </div>
  );
}
